/// <reference path="../../../../../rcwebmodels/geofencemodel.cs.d.ts" />
import * as React from 'react';
import * as ReactDom from 'react-dom';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from './PopupWindow';
import ReeferCallout from '../../actions/ReeferCallout';
import GeofenceMap from '../../actions/GeofenceMap';
import GeofenceManagement from '../../components/routecomponents/GeofenceManagement';
import { ReeferMap } from '../../components/childcomponents/ReeferMap';

import $ from 'jquery';
var Config: any = require('../../Config.json');

export interface AddGeofenceState {
    Params: server.GeofenceParams;
}

var self;
export class AddGeofence extends React.Component<any, AddGeofenceState> {
    constructor(props: any) {
        super(props);
        var inputParams: server.GeofenceParams = {
            FenceTypeCd: '', FenceId: '', FenceName: '', Address: '', Coordinates: [], ActionTypeCd: '',
            GeofenceCustomerID: ''
        };
        this.state = { Params: inputParams };

        self = this;
    }

    componentDidMount() {

        var inputParams: server.GeofenceParams = {
            FenceTypeCd: '', FenceId: '', FenceName: '', Address: '', Coordinates: [], ActionTypeCd: '',
            GeofenceCustomerID: ''
        };

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeofenceCategoryCds');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {

                if (data.length === 0) {
                    inputParams.FenceTypeCd = "B";
                    if (this.props.source != "Management") {
                        if ($("#DeviceFence").hasClass("active"))
                            $('#DeviceFence').removeClass('active');

                        if (!$("#ServerFence").hasClass("active"))
                            $('#ServerFence').addClass('active');
                    }
                }
                else if (data.includes('B') && data.includes('D')) {
                    inputParams.FenceTypeCd = "B";
                    if (this.props.source != "Management") {
                        if ($("#DeviceFence").hasClass("active"))
                            $('#DeviceFence').removeClass('active');

                        if (!$("#ServerFence").hasClass("active"))
                            $('#ServerFence').addClass('active');
                    }
                }
                else if (data.includes('B')) {
                    inputParams.FenceTypeCd = "B";
                    if (this.props.source != "Management") {
                        if ($("#DeviceFence").hasClass("active"))
                            $('#DeviceFence').removeClass('active');

                        if (!$("#ServerFence").hasClass("active"))
                            $('#ServerFence').addClass('active');
                    }
                }
                else if (data.includes('D')) {
                    inputParams.FenceTypeCd = "D";

                    if (this.props.source != "Management") {
                        if (!$("#DeviceFence").hasClass("active"))
                            $('#DeviceFence').addClass('active');

                        if ($("#ServerFence").hasClass("active"))
                            $('#ServerFence').removeClass('active');
                    }
                }
                this.state = { Params: inputParams };

                if (this.props.source == "Management") {
                    var fenceTypeCd = this.props.fenceTypeCd;
                    if (fenceTypeCd != undefined && fenceTypeCd != null) {
                        var params = this.state.Params;
                        params.FenceTypeCd = fenceTypeCd;
                        this.setState({
                            Params: params
                        });
                    }
                }
                this.resetDrawingFlag();

            });

    }

    componentWillReceiveProps(nextprops: any) {

        var inputParams: server.GeofenceParams = {
            FenceTypeCd: '', FenceId: '', FenceName: '', Address: '', Coordinates: [], ActionTypeCd: '',
            GeofenceCustomerID: ''
        };

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeofenceCategoryCds');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                if (data.length === 0) {
                    inputParams.FenceTypeCd = "B";
                    if (this.props.source != "Management") {
                        if ($("#DeviceFence").hasClass("active"))
                            $('#DeviceFence').removeClass('active');

                        if (!$("#ServerFence").hasClass("active"))
                            $('#ServerFence').addClass('active');
                    }
                }
                else if (data.includes('B') && data.includes('D')) {
                    inputParams.FenceTypeCd = "B";
                    if (this.props.source != "Management") {
                        if ($("#DeviceFence").hasClass("active"))
                            $('#DeviceFence').removeClass('active');

                        if (!$("#ServerFence").hasClass("active"))
                            $('#ServerFence').addClass('active');
                    }
                }
                else if (data.includes('B')) {
                    inputParams.FenceTypeCd = "B";
                    if (this.props.source != "Management") {
                        if ($("#DeviceFence").hasClass("active"))
                            $('#DeviceFence').removeClass('active');

                        if (!$("#ServerFence").hasClass("active"))
                            $('#ServerFence').addClass('active');
                    }
                }
                else if (data.includes('D')) {
                    inputParams.FenceTypeCd = "D";
                    if (this.props.source != "Management") {
                        if (!$("#DeviceFence").hasClass("active"))
                            $('#DeviceFence').addClass('active');

                        if ($("#ServerFence").hasClass("active"))
                            $('#ServerFence').removeClass('active');
                    }
                }
                this.state = { Params: inputParams };

                if (this.props.source == "Management") {
                    var fenceTypeCd = this.props.fenceTypeCd;
                    if (fenceTypeCd != undefined && fenceTypeCd != null) {
                        var params = this.state.Params;
                        params.FenceTypeCd = fenceTypeCd;
                        this.setState({
                            Params: params
                        });
                    }
                }
                this.resetDrawingFlag();
            });
    }

    resetDrawingFlag() {
        if (this.props.source == "Management")
            GeofenceMap.resetFlag();
        else
            ReeferCallout.resetFlag();
    }

    continueDrawing() {
        if (this.props.source == "DashBoard")
            ReeferCallout.ContinueDrawing();
        else
            GeofenceMap.ContinueDrawing();
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    cancelDrawing() {
        if (this.props.source == "DashBoard")
            ReeferCallout.CancelDrawing();
        else
            GeofenceMap.CancelDrawing();
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    submitDrawing() {
        var latlonArray = [];
        if (this.props.source == "Management") {
            var fenceTypeCd = this.props.fenceTypeCd;
            if (fenceTypeCd != undefined && fenceTypeCd != null) {
                var params = this.state.Params;
                params.FenceTypeCd = fenceTypeCd;
                this.setState({
                    Params: params
                });
            }
        }
        var inputParams = this.state.Params;
        var message = this.validateAddGeofence(inputParams);
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            return;
        }
        else {
            $("#globalLoader").show();

            var latlonArray: any[] = this.props.geofenceCoordinates;
            //$.each(coordinates, function (index, value) {
            //    if ((index === (coordinates.length - 1)) || !(latlonArray.indexOf(value.latitude.toFixed(9) + ',' + value.longitude.toFixed(9)) > -1))
            //        latlonArray.push(value.latitude.toFixed(9) + ',' + value.longitude.toFixed(9));
            //});
            inputParams.Coordinates = latlonArray;
            inputParams.ActionTypeCd = "A";
            inputParams.GeofenceCustomerID = this.state.Params.FenceId;

            var geofenceParams = JSON.stringify(inputParams);

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/SaveGeoFence', { method: 'POST', body: geofenceParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string>)
                .then(message => {
                    if (message == "Geofence created successfully.") {
                        //$("#globalLoader").hide();
                        if (this.props.source == "DashBoard") {
                            ReeferCallout.ResetDrawing();
                            ReeferMap.refreshDashBoardMap();
                        }
                        else {
                            GeofenceMap.ResetDrawing();
                            GeofenceManagement.loadGeofences(this.state.Params.FenceTypeCd);
                        }
                        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
                    }
                    else {
                        $("#globalLoader").hide();
                        PopupWindow.showErrorMessage("Alert", message);
                    }

                });
        }
    }

    validateAddGeofence(params: any) {
        if (params.FenceTypeCd === '' || params.FenceTypeCd === undefined) {
            return "Please select Fence Type";
        }
        else if (params.FenceId === '' || params.FenceId === undefined) {
            return "Please enter Fence ID"
        }
        else if (params.FenceName === '' || params.FenceName === undefined) {
            return "Please enter Fence Name"
        }

        return "";
    }

    FenceIdchange(event: React.FormEvent<HTMLInputElement>) {
        var params = this.state.Params;
        var Value: string = event.currentTarget.value;
        if (Value.length > 32)
            return false;
        params.FenceId = Value;

        this.setState({
            Params: params
        });
    }

    FenceNamechange(event: React.FormEvent<HTMLInputElement>) {
        var params = this.state.Params;
        var Value: string = event.currentTarget.value;
        if (Value.length > 100)
            return false;
        params.FenceName = Value;

        this.setState({
            Params: params
        });
    }

    Addresschange(event: React.FormEvent<HTMLTextAreaElement>) {
        var params = this.state.Params;
        var Value: string = event.currentTarget.value;
        if (Value.length > 250)
            return false;
        params.Address = Value;

        this.setState({
            Params: params
        });
    }

    radioButtonChange(value) {
        var params = self.state.Params;
        if (value == "B") {
            params.FenceTypeCd = value;
             document.getElementById("DeviceFence").classList.remove("active");
             document.getElementById("ServerFence").classList.add("active");
        }
        else {
            params.FenceTypeCd = value;
            document.getElementById("ServerFence").classList.remove("active");
            document.getElementById("DeviceFence").classList.add("active");
        }

        self.setState({
            Params: params
        });
    }

    public render() {
        return <div>
            <div className="row mt-2">
                <div className="col-md-4"></div>
                <div className="col-md-6">
                    <div id="divRadioButton" hidden={this.props.source == 'Management' ? true : false}>
                        <div className="btn-group btn-group-dsd" role="group" data-bs-toggle="buttons">
                            <input type="radio" className="btn-check" value="D" name="options" checked={this.state.Params.FenceTypeCd == 'D'} />
                            <label id="DeviceFence" className="btn btn-outline-secondary active" onClick={this.radioButtonChange.bind(this, 'D')}>
                                Device Geofence
                            </label>
                            <input type="radio" className="btn-check" value="B" name="options" checked={this.state.Params.FenceTypeCd == 'B'} />
                            <label id="ServerFence" className="btn btn-outline-secondary" onClick={this.radioButtonChange.bind(this, 'B')}>
                                Server Geofence
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-2">
                <div className="col-md-4 pe-0 text-md-end"><label className='col-form-label mandatory-label'> Fence ID :</label></div>
                <div className="col-md-6"><input type="text" className='form-control' onChange={e => this.FenceIdchange(e)} value={this.state.Params.FenceId} /></div>
            </div>
            <div className="row mt-2">
                <div className="col-md-4 pe-0 text-md-end"><label className='col-form-label mandatory-label'> Fence Name :</label></div>
                <div className="col-md-6"><input type="text" className='form-control' onChange={e => this.FenceNamechange(e)} value={this.state.Params.FenceName} /></div>
            </div>
            <div className="row mt-2">
                <div className="col-md-4 pe-0 text-md-end"><label className='col-form-label'> Address :</label></div>
                <div className="col-md-6"><textarea className='form-control texarea-100' onChange={e => this.Addresschange(e)} value={this.state.Params.Address} ></textarea></div>
            </div>

            <div className='modal-footer mt-2'>
                <button type='button' className='btn btn btn-secondary' onClick={this.cancelDrawing.bind(this)}>Cancel</button>
                <button type='button' className='btn btn-primary' onClick={this.continueDrawing.bind(this)}>Continue Drawing</button>
                <button type='button' className='btn btn-primary' onClick={this.submitDrawing.bind(this)}>Save</button>

            </div>

        </div>
    }
}

interface EditGeofenceState {
    Params: server.GeofenceParams;
    currentFence: server.GetGeofenceCoordinates;
    geofencesData: server.GetGeofenceCoordinates[];
}

export class EditGeofence extends React.Component<any, EditGeofenceState> {
    constructor(props: any) {
        super(props);
        var inputParams: server.GeofenceParams = { FenceTypeCd: '', FenceId: '', FenceName: '', Address: '', Coordinates: [], ActionTypeCd: '', GeofenceCustomerID: '' };
        this.state = { Params: inputParams, currentFence: this.props.currentFence, geofencesData: this.props.geofencesData };

        self = this;
    }

    componentDidMount() {
        var selectedItem = this.props.currentFence;
        if (selectedItem != undefined && selectedItem != null) {
            this.setState({ currentFence: selectedItem });
            this.bindFenceData(selectedItem);
        }
        var geodata = this.props.geofencesData;
        if (geodata != undefined && geodata != null && geodata.length > 0) {
            this.setState({ geofencesData: geodata });
        }
        if (this.props.source == "Management") {
            var fenceTypeCd = this.props.fenceTypeCd;
            if (fenceTypeCd != undefined && fenceTypeCd != null) {
                var params = this.state.Params;
                params.FenceTypeCd = fenceTypeCd;
                this.setState({
                    Params: params
                });
            }
        }
        this.resetDrawingFlag();
    }

    componentWillReceiveProps(nextprops: any) {
        var selectedItem = nextprops.currentFence;
        if (selectedItem != undefined && selectedItem != null) {
            this.setState({ currentFence: selectedItem });
            this.bindFenceData(selectedItem);
        }
        var geodata = this.props.geofencesData;
        if (geodata != undefined && geodata != null && geodata.length > 0) {
            this.setState({ geofencesData: geodata });
        }
        if (this.props.source == "Management") {
            var fenceTypeCd = this.props.fenceTypeCd;
            if (fenceTypeCd != undefined && fenceTypeCd != null) {
                var params = this.state.Params;
                params.FenceTypeCd = fenceTypeCd;
                this.setState({
                    Params: params
                });
            }
        }
        this.resetDrawingFlag();
    }

    resetDrawingFlag() {
        if (this.props.source == "Management")
            GeofenceMap.resetFlag();
        else
            ReeferCallout.resetFlag();
    }

    bindFenceData(fenceData: any) {
        var inputParams = this.state.Params;
        inputParams.FenceId = fenceData.Tag;
        inputParams.FenceName = fenceData.Name;
        inputParams.FenceTypeCd = fenceData.GeofenceCategoryCd;
        inputParams.Address = fenceData.Address;
        inputParams.GeofenceCustomerID = fenceData.GeofenceCustomerID;
        this.setState({ Params: inputParams });
        this.radioButtonChange(fenceData.GeofenceCategoryCd);
    }

    continueDrawing() {
        if (this.props.source == "DashBoard")
            ReeferCallout.ContinueDrawing();
        else
            GeofenceMap.ContinueDrawing();
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    cancelDrawing() {
        if (this.props.source == "DashBoard") {
            ReeferCallout.CancelDrawing();
            ReeferCallout.BindGeofencePolygons(this.state.geofencesData);
        }
        else {
            GeofenceMap.CancelDrawing();
            GeofenceMap.BindGeofencePolygons(this.state.geofencesData);
        }
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    submitDrawing() {
        var latlonArray = [];
        if (this.props.source == "Management") {
            var fenceTypeCd = this.props.fenceTypeCd;
            if (fenceTypeCd != undefined && fenceTypeCd != null) {
                var params = this.state.Params;
                params.FenceTypeCd = fenceTypeCd;
                this.setState({
                    Params: params
                });
            }
        }
        var inputParams = this.state.Params;
        var message = this.validateEditGeofence(inputParams);
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            return;
        }
        else {

            $("#globalLoader").show();

            var latlonArray: any[] = this.props.geofenceCoordinates;
            //$.each(coordinates, function (index, value) {
            //    if ((index === (coordinates.length - 1)) || !(latlonArray.indexOf(value.latitude.toFixed(9) + ',' + value.longitude.toFixed(9)) > -1))
            //        latlonArray.push(value.latitude.toFixed(9) + ',' + value.longitude.toFixed(9));
            //});
            inputParams.Coordinates = latlonArray;
            inputParams.ActionTypeCd = "U";

            var geofenceParams = JSON.stringify(inputParams);

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/SaveGeoFence', { method: 'POST', body: geofenceParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string>)
                .then(message => {
                    if (message == "Geofence updated successfully.") {
                        //$("#globalLoader").hide();
                        if (this.props.source == "DashBoard") {
                            ReeferCallout.ResetDrawing();
                            ReeferMap.refreshDashBoardMap();
                        }
                        else {
                            GeofenceMap.ResetDrawing();
                            GeofenceManagement.loadGeofences(this.state.Params.FenceTypeCd);
                        }
                        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
                    }
                    else {
                        $("#globalLoader").hide();
                        PopupWindow.showErrorMessage("Alert", message);
                    }

                });
        }
    }

    validateEditGeofence(params: any) {

        if (params.FenceTypeCd === '' || params.FenceTypeCd === undefined) {
            return "Please select Fence Type";
        }
        else if (params.FenceId === '' || params.FenceId === undefined) {
            return "Please enter Fence ID"
        }
        else if (params.FenceName === '' || params.FenceName === undefined) {
            return "Please enter Fence Name"
        }

        return "";
    }

    FenceIdchange(event: React.FormEvent<HTMLInputElement>) {
        var params = this.state.Params;
        var Value: string = event.currentTarget.value;
        if (Value.length > 32)
            return false;
        params.FenceId = Value;

        this.setState({
            Params: params
        });
    }

    FenceNamechange(event: React.FormEvent<HTMLInputElement>) {
        var params = this.state.Params;
        var Value: string = event.currentTarget.value;
        if (Value.length > 100)
            return false;
        params.FenceName = Value;

        this.setState({
            Params: params
        });
    }

    Addresschange(event: React.FormEvent<HTMLTextAreaElement>) {
        var params = this.state.Params;
        var Value: string = event.currentTarget.value;
        if (Value.length > 250)
            return false;
        params.Address = Value;

        this.setState({
            Params: params
        });
    }

    radioButtonChange(value) {
        var params = self.state.Params;
        if (value == "B") {
            if ($("#lblradioButtonDevice").hasClass("active")) $('#lblradioButtonDevice').removeClass('active');
            if (!$("#lblradioButtonServer").hasClass("active")) $('#lblradioButtonServer').addClass('active');
        }
        else {            
            if ($("#lblradioButtonServer").hasClass("active")) $('#lblradioButtonServer').removeClass('active');
            if (!$("#lblradioButtonDevice").hasClass("active")) $('#lblradioButtonDevice').addClass('active');
        }
        params.FenceTypeCd = value;
        self.setState({
            Params: params
        });
    }

    public render() {
        return <div>
            <div className="row mt-2">
                <div className="col-md-4"></div>
                <div className="col-md-6">
                    <div id="divRadioButton" hidden={this.props.source == 'Management' ? true : false}>
                        <div className="btn-group btn-group-dsd" role="group" data-bs-toggle="buttons" hidden={this.props.source == 'Management' ? true : false}>
                            <input type="radio" className="btn-check" value="D" name="options" />
                            <label className="btn btn-outline-secondary active" id="lblradioButtonDevice" onClick={this.radioButtonChange.bind(this, this.state.Params.FenceTypeCd)}>
                              Device Geofence
                            </label>
                            <input type="radio" className="btn-check" value="B" name="options" />
                            <label className="btn btn-outline-secondary" id="lblradioButtonServer" onClick={this.radioButtonChange.bind(this, this.state.Params.FenceTypeCd)}>
                                Server Geofence
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-2">
                <div className="col-md-4 pe-0 text-md-end"><span className='col-form-label mandatory-label'> Fence ID :</span></div>
                <div className="col-md-6"><input type="text" className='form-control' onChange={e => this.FenceIdchange(e)} value={this.state.Params.FenceId} /></div>
            </div>
            <div className="row mt-2">
                <div className="col-md-4 pe-0 text-md-end"><span className='col-form-label mandatory-label'> Fence Name :</span></div>
                <div className="col-md-6"><input type="text" className='form-control' onChange={e => this.FenceNamechange(e)} value={this.state.Params.FenceName} /></div>
            </div>
            <div className="row mt-2">
                <div className="col-md-4 pe-0 text-md-end"><span className='col-form-label'> Address :</span></div>
                <div className="col-md-6"><textarea className='form-control texarea' onChange={e => this.Addresschange(e)} value={this.state.Params.Address} ></textarea></div>
            </div>

            <div className='modal-footer mt-2'>
                <button type='button' className='btn btn btn-secondary' onClick={this.cancelDrawing.bind(this)}>Cancel</button>
                <button type='button' className='btn btn-primary' onClick={this.continueDrawing.bind(this)}>Continue Drawing</button>
                <button type='button' className='btn btn-primary' onClick={this.submitDrawing.bind(this)}>Save</button>

            </div>

        </div>
    }
}